import React from 'react';
import DigitalMarketing from '../../img/Course-Elements/DigitalMarketing.png';
import GraphicsDesigning from '../../img/Course-Elements/GraphicDesigning.png';
import DataScience from '../../img/Course-Elements/DataScience.png';
import GSOC from '../../img/Course-Elements/GSocCC.png';
import ArVrMr from '../../img/Course-Elements/ArVrMr.png';
import Blockchain from '../../img/Course-Elements/Blockchain.png';
import Internet from '../../img/Course-Elements/InternetOfThings.png';
import CloudComputing from '../../img/Course-Elements/CloudComputing.png';
import WebDevelopment from '../../img/Course-Elements/WevDev.png';
import ML from '../../img/Course-Elements/ML.png';
import AppDevelopment from '../../img/Course-Elements/AndroidAppDev.png';
import FullStack from '../../img/Course-Elements/FullStackDev.png';
import { useNavigate } from 'react-router-dom';

const ExclusiveCourses = () => {
    const navigate = useNavigate();

    return (
        <div>
            <h1 className='text-5xl text-blue-400'>Learn by Our Exclusive Courses</h1>
            <h4 className='text-2xl mb-4'>Learn new-age skills on the go</h4>
            <div className='grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-12'>

                <div onClick={() => navigate('/digital-marketing')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={DigitalMarketing} alt="" className='mb-2 w-100' />
                    <h2>Digital Marketing</h2>
                </div>
                <div onClick={() => navigate('/graphics-designing')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={GraphicsDesigning} alt="" className='mb-2 w-100' />
                    <h2>Graphics Designing</h2>
                </div>
                <div onClick={() => navigate('/data-science')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={DataScience} alt="" className='mb-2 w-100' />
                    <h2>Data Science</h2>
                </div>
                <div onClick={() => navigate('/GSOC')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={GSOC} alt="" className='mb-2 w-100' />
                    <h2>GSOC Crash Course</h2>
                </div>
                <div onClick={() => navigate('/ar-vr-mr')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={ArVrMr} alt="" className='mb-2 w-100' />
                    <h2> AR, VR, and MR</h2>
                </div>
                <div onClick={() => navigate('/blockchain')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={Blockchain} alt="" className='mb-2 w-100' />
                    <h2> Blockchain technology</h2>
                </div>
                <div onClick={() => navigate('/internet-things')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={Internet} alt="" className='mb-2 w-100' />
                    <h2> Internet of Things</h2>
                </div>
                <div onClick={() => navigate('/cloud-computing')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={CloudComputing} alt="" className='mb-2 w-100' />
                    <h2>Cloud Computing </h2>
                </div>
                <div onClick={() => navigate('/web-development')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={WebDevelopment} alt="" className='mb-2 w-100' />
                    <h2>Web development </h2>
                </div>
                <div onClick={() => navigate('/machine-learning')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={ML} alt="" className='mb-2 w-100' />
                    <h2>Machine Learning </h2>
                </div>
                <div onClick={() => navigate('/android-app-development')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={AppDevelopment} alt="" className='mb-2 w-100' />
                    <h2>Android APP Development</h2>
                </div>
                <div onClick={() => navigate('/full-stack-web-development')} className='hover:cursor-pointer hover:bg-gray-200 px-2 py-1 hover:rounded-md'>
                    <img src={FullStack} alt="" className='mb-2 w-100' />
                    <h2>Full Stack Developer</h2>
                </div>
            </div>
        </div>
    );
};

export default ExclusiveCourses;